import { useState } from 'react';
import { MarketingDataProvider } from './MarketingContext';
import MarketingLayout from './MarketingLayout';
import { MarketingPage } from './types';
import Dashboard from './pages/Dashboard';
import CompaniesPage from './pages/CompaniesPage';
import ProjectsPage from './pages/ProjectsPage';
import ProductsPage from './pages/ProductsPage';
import StrategyPage from './pages/StrategyPage';
import CampaignsPage from './pages/CampaignsPage';
import ContentCalendarPage from './pages/ContentCalendarPage';
import SEOPage from './pages/SEOPage';
import ResearchPage from './pages/ResearchPage';
import KnowledgebasePage from './pages/KnowledgebasePage';
import StandardsPage from './pages/StandardsPage';
import BlogsPage from './pages/BlogsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import DocumentsPage from './pages/DocumentsPage';
import TasksPage from './pages/TasksPage';
import SettingsPage from './pages/SettingsPage';

interface Props {
  onBackToPortal: () => void;
}

export default function MarketingPortal({ onBackToPortal }: Props) {
  const [currentPage, setCurrentPage] = useState<MarketingPage>('marketing-dashboard');

  const renderPage = () => {
    switch (currentPage) {
      case 'marketing-dashboard': return <Dashboard onNavigate={setCurrentPage} />;
      case 'marketing-companies': return <CompaniesPage onNavigate={setCurrentPage} />;
      case 'marketing-projects': return <ProjectsPage onNavigate={setCurrentPage} />;
      case 'marketing-products': return <ProductsPage onNavigate={setCurrentPage} />;
      case 'marketing-strategy': return <StrategyPage />;
      case 'marketing-campaigns': return <CampaignsPage />;
      case 'marketing-content': return <ContentCalendarPage />;
      case 'marketing-seo': return <SEOPage />;
      case 'marketing-research': return <ResearchPage />;
      case 'marketing-knowledge': return <KnowledgebasePage />;
      case 'marketing-standards': return <StandardsPage />;
      case 'marketing-blogs': return <BlogsPage />;
      case 'marketing-analytics': return <AnalyticsPage />;
      case 'marketing-documents': return <DocumentsPage />;
      case 'marketing-tasks': return <TasksPage />;
      case 'marketing-settings': return <SettingsPage />;
      default: return <Dashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <MarketingDataProvider>
      <MarketingLayout
        currentPage={currentPage}
        onNavigate={setCurrentPage}
        onBackToPortal={onBackToPortal}
      >
        {renderPage()}
      </MarketingLayout>
    </MarketingDataProvider>
  );
}
